import { ContactProperties } from 'forms-utils-lib/constants/Properties';
import isContactField from './isContactField';
const isContactEmailField = field => {
  const isContact = isContactField(field);
  const isEmail = field.name === ContactProperties.email;
  return isContact && isEmail;
};
export default isContactEmailField;